<template>
    <div>
        <LiveSession v-if="joinedSession" />
        <ProducerDashboard
            v-else
            :displayName="displayName"
            @joinSession="joinSession()"
        />
    </div>
</template>

<script>
import ProducerDashboard from "./ProducerDashboard";
import LiveSession from "../LiveSession";

export default {
    name: "HostPage",
    data() {
        return {
        };
    },
    computed: {
        displayName() {
            return (
                this.$store.getters.user && this.$store.getters.user.displayName
            );
        },

        joinedSession() {
            return this.$store.state.joinedSession;
        },
    },
    methods: {
        joinSession() {
            this.$store.dispatch("joinSession");
        },
    },

    components: {
        ProducerDashboard,
        LiveSession,
    },
};
</script>